const ErrorPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-red-50 to-red-100 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
      <div className="text-5xl mb-4">⚠️</div>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">
        Something Went Wrong
      </h1>
      <p className="text-gray-600 mb-6">
        An unexpected error occurred. Please try refreshing the page.
      </p>
      <div className="space-y-3">
        <button
          onClick={() => window.location.reload()}
          className="w-full px-4 py-2 bg-electric-600 text-white rounded-lg hover:bg-electric-700 transition-colors"
        >
          Refresh Page
        </button>
        <a
          href="/"
          className="block w-full px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
        >
          Go Home
        </a>
      </div>
    </div>
  </div>
);

export default ErrorPage;
